'use client'

import { Icon, InputBar } from '@vinted/web-ui'
import { FormEvent, useRef } from 'react'
import { v4 as uuid } from 'uuid'

import { AiSparkles16, Search16 } from '@vinted/monochrome-icons'

import { navigateToPage } from '@marketplace-web/shared/browser-util'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { cookiesDataByName, useCookie } from '@marketplace-web/environment/cookies-util'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { urlWithParams } from '@marketplace-web/shared/utils'
import { AccessChannel } from '@marketplace-web/help-center/help-center-faq-entry-url-data'
import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

import { HELP_SEARCH_URL } from '../constants/routes'

const HelpCenterSearchInputNew = ({ value = '' }) => {
  const translate = useTranslate('help_center.ai_search')
  const isAiPoweredHelpFeatureEnabled = useFeatureSwitch('help_center_ai_powered_help')
  const aiPoweredHelpWebAbTest = useAbTest('ai_help_chatbot_v2')
  const isAiPoweredHelpEnabled =
    aiPoweredHelpWebAbTest?.variant === 'on' && isAiPoweredHelpFeatureEnabled
  const searchRef = useRef<HTMLInputElement>(null)
  const cookies = useCookie()

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const searchTerm = searchRef.current?.value

    if (!searchTerm) return
    cookies.set(cookiesDataByName.help_center_search_session_id, uuid())

    navigateToPage(
      urlWithParams(HELP_SEARCH_URL, {
        search_text: searchTerm,
        access_channel: AccessChannel.HcSearch,
      }),
    )
  }

  return (
    <form onSubmit={handleSubmit}>
      <InputBar
        value={value || searchRef.current?.value}
        icon={<Icon name={isAiPoweredHelpEnabled ? AiSparkles16 : Search16} />}
        name="help-center-search"
        placeholder={translate('input_placeholder')}
        ref={searchRef}
        data-testId="help-center-new-search-text"
      />
    </form>
  )
}

export default HelpCenterSearchInputNew
